<label
    class="anc-radio"
    [class.anc-radio--checked]="isChecked()"
    [class.anc-radio--disabled]="isDisabled()"
>
    <input
        type="radio"
        class="anc-radio__input"
        [attr.name]="group.resolvedName()"
        [value]="value()"
        [checked]="isChecked()"
        [disabled]="isDisabled()"
        (change)="onSelect()"
    />
    <span class="anc-radio__circle" aria-hidden="true"></span>
    <span class="anc-radio__label" *ngIf="label()" translate>{{ label() }}</span>
    <ng-content></ng-content>
</label>
